/**
 * デッキのバージョンのレシピの差をカード名で（Issue #956）。diff は GetDeck の版の `diff`・GetDeckVersionDiff の返り
 * {added: [{card_id, card_name, zone, n}], removed: [...]}。
 */
const line = (c) => `${c.card_name}${c.n > 1 ? ` ×${c.n}` : ''}${c.zone === 'extra' ? '（EX）' : ''}`;

/** 一行の要約（純関数）: 「＋A ×2、B ／ −C」。差が無ければ「変更なし」 */
export function diffSummary(diff) {
  if (!diff) return '';
  const plus = (diff.added ?? []).map((c) => `＋${line(c)}`);
  const minus = (diff.removed ?? []).map((c) => `−${line(c)}`);
  if (!plus.length && !minus.length) return '変更なし';
  return [plus.join('、'), minus.join('、')].filter(Boolean).join(' ／ ');
}

export default function DeckDiff({ diff }) {
  if (!diff) return <span className="card-meta">—</span>;
  const added = diff.added ?? [];
  const removed = diff.removed ?? [];
  if (!added.length && !removed.length) return <span className="card-meta">変更なし</span>;
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 2, fontSize: '0.8rem' }} data-testid="deck-diff">
      {added.map((c) => <span key={`a${c.zone}${c.card_id}`} style={{ color: '#6ee89a' }}>＋ {line(c)}</span>)}
      {removed.map((c) => <span key={`r${c.zone}${c.card_id}`} style={{ color: '#e89a9a' }}>− {line(c)}</span>)}
    </div>
  );
}
